import { buildModelManager } from "../builder.js";
const DefaultClinicalEvaluationSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  createdById: true,
  modelOutput: { markdown: true, truncatedHTML: true },
  needsHitl: true,
  parsedOutput: true,
  passStatus: true,
  patientId: true,
  processorVersion: true,
  rawInput: true,
  reviewedAt: true,
  reviewerId: true,
  shiftId: true,
  shiftProcessingId: true,
  updatedAt: true,
  valid: true,
  validationErrors: true
};
const modelApiIdentifier = "clinicalEvaluation";
const pluralModelApiIdentifier = "clinicalEvaluations";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultClinicalEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultClinicalEvaluationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalEvaluationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultClinicalEvaluationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultClinicalEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultClinicalEvaluationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createClinicalEvaluation",
    operationReturnType: "CreateClinicalEvaluation",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      clinicalEvaluation: { required: false, type: "CreateClinicalEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClinicalEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkCreateClinicalEvaluations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateClinicalEvaluationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultClinicalEvaluationSelection
  },
  {
    type: "action",
    operationName: "updateClinicalEvaluation",
    operationReturnType: "UpdateClinicalEvaluation",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      clinicalEvaluation: { required: false, type: "UpdateClinicalEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClinicalEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateClinicalEvaluations",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateClinicalEvaluationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultClinicalEvaluationSelection
  },
  {
    type: "action",
    operationName: "deleteClinicalEvaluation",
    operationReturnType: "DeleteClinicalEvaluation",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteClinicalEvaluations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertClinicalEvaluation",
    operationReturnType: "UpsertClinicalEvaluation",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      clinicalEvaluation: { required: false, type: "UpsertClinicalEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateClinicalEvaluationResult": { hasReturnType: false },
      "... on UpdateClinicalEvaluationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultClinicalEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertClinicalEvaluations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertClinicalEvaluationsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultClinicalEvaluationSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "clinicalEvaluationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ClinicalEvaluationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultClinicalEvaluationSelection,
  operations
);
export {
  ClinicalEvaluationManager,
  DefaultClinicalEvaluationSelection
};
//# sourceMappingURL=ClinicalEvaluation.js.map
